import { Controller } from "@hotwired/stimulus";

// Populates a hidden form field with the browser's IANA timezone so the
// onboarding controller has it regardless of the browser_time_zone cookie's
// host scoping (cookie is set on app.lastbot.com but the form is often
// submitted from a subdomain).
//
// The onboarding page loads the dedicated "onboarding" Vite entrypoint, whose
// controller index (controllers/hub/onboarding/index.js) globs from THIS
// directory — so the identifier is just "browser-timezone" (like "modal"),
// not the "hub--onboarding--" prefixed form the main entrypoint would use.
//
// Usage in template (attached directly to the hidden input):
//   <%= hidden_field_tag :browser_time_zone, "",
//         data: { controller: "browser-timezone" } %>
export default class extends Controller {
  static targets = ["field"];

  connect() {
    // If the controller is attached directly to an input, this.element IS
    // the field. Otherwise expect a `field` target on a descendant.
    const target = this.hasFieldTarget ? this.fieldTarget : this.element;
    if (!target || target.value) return;
    try {
      target.value = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    } catch {
      // Intl is universally supported; if it ever throws, just leave empty
      // and let the server fall through to other detection signals.
    }
  }
}
